import { FieldType, VariableType } from '../Field';
import { SelectionMode } from '../Filter';
import { FFuncType } from '../Formula/FormulaFunc';
export class FilterCollect {
    constructor(query, result) {
        this._query = query;
        this._result = result;
        this._collect = this.buildCollect();
    }
    get query() {
        return this._query;
    }
    get result() {
        return this._result;
    }
    get collect() {
        return this._collect;
    }
    buildCollect() {
        const filters = new Array();
        const filterFuncs = new Array();
        for (const [fieldName, filter] of Array.from(this.query.filters)) {
            filters.push(filter);
        }
        let field;
        for (const filter of filters) {
            field = filter.field;
            switch (filter.varType) {
                case VariableType.CONTINUOUS: {
                    const range = filter.range;
                    if (field.type === FieldType.VIEWCALC && field.formula.expr.type === FFuncType.SCALAR) {
                        const expression = field.formula.expr;
                        const minValue = range.min;
                        const maxValue = range.max;
                        let minFilter;
                        let maxFilter;
                        if (minValue === undefined || minValue === null || minValue === '') {
                            minFilter = (value) => {
                                return true;
                            };
                        }
                        else if (range.includeMin) {
                            minFilter = (value) => {
                                return value >= minValue;
                            };
                        }
                        else {
                            minFilter = (value) => {
                                return value > minValue;
                            };
                        }
                        if (maxValue === undefined || maxValue === null || maxValue === '') {
                            maxFilter = (value) => {
                                return true;
                            };
                        }
                        else if (range.includeMax) {
                            maxFilter = (value) => {
                                return value <= maxValue;
                            };
                        }
                        else {
                            maxFilter = (value) => {
                                return value < maxValue;
                            };
                        }
                        filterFuncs.push((row) => {
                            const value = expression.value({ row });
                            if (value == null) {
                                return range.includeNulls;
                            }
                            else {
                                return minFilter(value) && maxFilter(value);
                            }
                        });
                    }
                    break;
                }
                case VariableType.DISCRETE: {
                    const selected = filter.selection.selected;
                    const inclusionMode = filter.selection.mode;
                    if (field.type === FieldType.VIEWCALC && field.formula.expr.type === FFuncType.SCALAR) {
                        const expression = field.formula.expr;
                        filterFuncs.push((row) => {
                            const value = expression.value({ row });
                            switch (inclusionMode) {
                                case SelectionMode.ALL:
                                    return true;
                                case SelectionMode.INCLUDE:
                                    if (selected.has(value)) {
                                        return true;
                                    }
                                    else {
                                        return false;
                                    }
                                case SelectionMode.EXCLUDE:
                                    if (selected.has(value)) {
                                        return false;
                                    }
                                    else {
                                        return true;
                                    }
                            }
                        });
                    }
                    break;
                }
            }
        }
        return (row, index) => {
            for (const filterFunc of filterFuncs) {
                if (!filterFunc(row)) {
                    return;
                }
            }
            this.result.addRow(row);
        };
    }
}
